import { Component, input } from '@angular/core';

// Feuille du dossier posee sur le bureau : trombone, en-tete (rubrique, tampon,
// reference) et decor. Le contenu de l'ecran est projete dessous.
@Component({
  selector: 'app-dossier',
  templateUrl: './dossier.html',
})
export class Dossier {
  readonly eyebrow = input.required<string>();
  readonly stamp = input('Confidentiel');
  readonly reference = input<string | null>(null);
  readonly wide = input(false);
  // Tampon « accès autorisé » qui deborde a gauche et globe a droite.
  readonly decor = input(true);
}
